import { Core_Marketplace_Remixer_SearchQuery, Listing, reverb_search_SearchResponse } from '../gql/graphql';

export function itemSoldSprigEvent(): void {
  sprigEvent('web_item_sold', {});
}

export function publishedListingSprigEvent(listing: Listing): void {
  sprigEvent('web_item_listed', {
    'Brand': listing.brandSlug,
  });
}

export function searchResultsSprigEvent(searchResponse: reverb_search_SearchResponse): void {
  sprigEvent('web_search_results', {
    'Total Results': searchResponse.total || 0,
    'Listings': (searchResponse.listings || []).length,
    'Fallback Listings': (searchResponse.fallbackListings || []).length,
    'Suggested Queries': (searchResponse.suggestedQueries || []).length,
    'Suggestions': (searchResponse.suggestions || []).length,
  });
}


export function marketplaceSearchResultsSprigEvent(
  search: Core_Marketplace_Remixer_SearchQuery['marketplaceListingsSearch'],
  suggestedQueriesCount = 0,
): void {
  sprigEvent('web_search_results', {
    'Total Results': search?.pagination?.total || 0,
    'Listings': (search?.listings || []).length,
    'Suggested Queries': suggestedQueriesCount,
    'Suggestions': search?.queryInfo?.spellCorrected ? 1 : 0,
  });
}

export function tradeInAbandonedSprigEvent(): void {
  sprigEvent('web_trade_in_abandoned', {});
}

/*
 * Report events to Sprig using externally declared Sprig snippet
 */
export function sprigEvent(eventName: string, properties: any): void {
  if (window.Sprig) {
    // eslint-disable-next-line new-cap
    window.Sprig('identifyAndTrack', { eventName, properties });
  }
}
